import onboardingIllustration from '@images/onboarding-illustration.svg';

export const OnboardingIllustration: React.FC = ({}) => {
  return (
    <div className='px-15'>
      <img src={onboardingIllustration} className='h-[500px]' />
    </div>
  );
};
